import  {useRef } from "react";
import {
  CameraAlt as CameraAltIcon,
} from "@mui/icons-material";
import {
  Avatar,

} from "@mui/material";

import axiosInstance from "../configuration/request";
import { useSnackbar } from "./SnackbarContext";

import { Person as PersonIcon } from "@mui/icons-material";

export default function ProfileImageSection({ imageUrl ,SaveProfileImage}) {
  const showSnackbar = useSnackbar();
  const fileInputRef = useRef(null);

 const handleFileChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const maxFileSize = 1 * 1024 * 1024; // 2 MB

  if (file.size > maxFileSize) {
     showSnackbar("File must be less than 1 MB", "error");
    return;
  }

  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axiosInstance.post(
      "/customer/upload/file",
      formData
    );
    const fileUrl = response.data?.url || null;
    SaveProfileImage(fileUrl);
  } catch (error) {
    console.error("Upload failed:", error);
  }
};



  return (
       <div className="relative">
              <Avatar sx={{ width: 95, height: 95 }}>
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt="Profile"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <PersonIcon sx={{ fontSize: 40 }} />
                )}
              </Avatar>
              <div
                className="absolute bottom-0 right-0 bg-white rounded-full p-1 shadow-md cursor-pointer"
                onClick={() => fileInputRef.current.click()}
              >
                <CameraAltIcon className="text-[#02537F]" />
              </div>
              <input
                type="file"
                accept=".jpg, .jpeg"
                ref={fileInputRef}
                className="hidden"
                onChange={handleFileChange}
              />
            </div>
  );
}
